import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

import type { JSX } from "react";

export const WofLoader = (): JSX.Element => {
  return (
    <Box
      sx={{
        position: "relative",
        height: "100vh",
      }}
    >
      <CircularProgress
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      />
    </Box>
  );
};
